import RadioCardListPage from "@components/RadioCardListPage"
import {
  addAgeToLocalStorage,
  getIsFemaleFromLocalStorage,
} from "@helpers/localStorage"

export default function AgePage() {
  const isFemale = getIsFemaleFromLocalStorage()

  const OPTIONS = [
    { emoji: isFemale ? "\uD83D\uDC67" : "\uD83E\uDDD1", key: "18_24" },
    {
      emoji: isFemale
        ? "\uD83D\uDC69\u200D\uD83D\uDCBC"
        : "\uD83E\uDDD1\u200D\uD83D\uDCBC",
      key: "25_34",
    },
    { emoji: isFemale ? "\uD83D\uDC69" : "\uD83D\uDC68", key: "35_44" },
    {
      emoji: isFemale ? "\uD83D\uDC69\u200D\uD83E\uDDB3" : "\uD83E\uDDD3",
      key: "45_54",
    },
    { emoji: isFemale ? "\uD83D\uDC75" : "\uD83D\uDC74", key: "55_64" },
    { emoji: "\uD83C\uDF96\uFE0F", key: "65_plus" },
    { emoji: "\uD83D\uDCAB", key: "other" },
  ]

  const handleBeforeSubmit = (_value: string, key: string) => {
    addAgeToLocalStorage(key)
  }

  return (
    <RadioCardListPage
      translationKey="ageV2"
      options={OPTIONS}
      subtitle="subtitle"
      onBeforeSubmit={handleBeforeSubmit}
    />
  )
}
